import { Avatar, Stack, Typography } from "@mui/material";
import { UserContext } from "context/userContext";
import { useContext } from "react";
import palette, { TEAM_MEMBER_AVATAR_COLORS } from "theme/palette";
import { TeamMember } from "./tableConfig/types";

type TeamMemberEmployeeProps = {
  employee: TeamMember;
};

const getAvatarColor = (userId: string) => {
  const numericUserId = Number(userId);
  const colorIndex = Number.isNaN(numericUserId)
    ? Array.from(userId).reduce((sum, character) => sum + character.charCodeAt(0), 0)
    : numericUserId;

  return TEAM_MEMBER_AVATAR_COLORS[colorIndex % TEAM_MEMBER_AVATAR_COLORS.length];
};

const TeamMemberEmployee = ({ employee }: TeamMemberEmployeeProps) => {
  const { me } = useContext(UserContext);
  const { email, user } = employee.userEmail;
  const userFullName = user ? [user.lastName, user.firstName, user.middleName].filter(Boolean).join(" ") : "";
  const fullName = userFullName || "Нет имени";
  const initials = [user?.lastName, user?.firstName]
    .filter((name): name is string => Boolean(name))
    .map((name) => name[0])
    .join("")
    .toUpperCase();
  const isCurrentUser = me?.userEmail.email.toLowerCase() === email.toLowerCase();

  return (
    <Stack
      direction='row'
      alignItems='flex-start'
      spacing={1.25}
      sx={{ minWidth: 0 }}>
      <Stack
        direction='row'
        alignItems='center'
        spacing={1.25}
        sx={{ minWidth: 0 }}>
        <Avatar
          sx={{
            width: 32,
            height: 32,
            flexShrink: 0,
            backgroundColor: getAvatarColor(user?.id || ""),
            fontSize: 14,
            fontWeight: 700,
            color: palette.white,
          }}>
          {initials || email[0]?.toUpperCase()}
        </Avatar>
        <Stack
          spacing={0}
          sx={{ minWidth: 0 }}>
          <Typography
            variant='body16rg'
            sx={{
              fontWeight: 600,
              ...(userFullName ? {} : { color: "text.disabled", fontStyle: "italic" }),
              lineHeight: 1.35,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
            {fullName}
          </Typography>
          <Typography
            variant='body14rg'
            sx={{
              color: "text.disabled",
              lineHeight: 1.35,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
            {email}
          </Typography>
        </Stack>
      </Stack>
      {isCurrentUser && (
        <Typography
          variant='body14rg'
          sx={{
            lineHeight: 1.35,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            borderRadius: 2,
            backgroundColor: "third.main",
            color: "primary.main",
            fontWeight: 700,
            px: 1,
            py: 0.2,
          }}>
          Вы
        </Typography>
      )}
    </Stack>
  );
};

export default TeamMemberEmployee;
